import { useCallback } from 'react'

import { useDispatch } from 'react-redux'

import { basketRecipePortionChange } from 'actions/basket'
import type { RecipeUUID } from 'reducers/menu-recipes/recipes'

export type UpdateRecipePortionsByUuidFn = ReturnType<typeof useUpdateRecipePortionsByUuid>

export const useUpdateRecipePortionsByUuid = () => {
  const dispatch = useDispatch()

  return useCallback(
    (recipeId: RecipeUUID, numPortions: number) => {
      dispatch(basketRecipePortionChange(recipeId, numPortions))
    },
    [dispatch],
  )
}
